// Maison Dodji — Private QA fixture Space.
//
// PRIVATE, TECHNICAL, NOT AN AUTHENTIC PROJECT.
//
// This file exists to validate the Project Space rendering, sealed-state,
// colophon and bilingual layout in a real build. It is displayed with an
// explicit banner marking it as a fixture. It is not linked from anywhere.
//
// It is deliberately written in a sober, generic register that carries
// no real Named Party identity. All names, dates and pieces are placeholders.

const qaFixtureAlpha = {
  token: "qa-fixture-alpha",
  fixture: true,
  language: "fr",
  namedParty: "— (fixture)",
  projectTitle: "Étude technique",
  pieceName: "—",
  studyOpenedOn: "2026-05-30",
  sealed: false,

  chapters: [
    {
      type: "salutation",
      body: {
        fr: [
          "Ce chapitre est une fixture technique. Il ne s'adresse à personne en particulier et n'engage aucune étude.",
          "Il permet de vérifier la mise en page, le rythme et la clôture d'un Space avant l'ouverture du premier chapitre authentique.",
        ],
        en: [
          "This chapter is a technical fixture. It addresses no one in particular and engages no study.",
          "It exists to verify the layout, the rhythm and the sealing of a Space before the first authentic chapter is opened.",
        ],
      },
    },

    {
      type: "compris",
      body: {
        fr: [
          "La Maison inscrit ici, en quelques paragraphes, ce qu'elle a retenu de la conversation d'ouverture.",
          "Rien ne surprend le lecteur : chaque phrase reprend un élément déjà discuté. Le chapitre ne propose pas — il récapitule.",
          "Le registre reste sobre, sans emphase, sans promesse.",
        ],
        en: [
          "The Maison inscribes here, in a few paragraphs, what it retained from the opening conversation.",
          "Nothing surprises the reader: every sentence recovers an element already discussed. The chapter does not propose — it summarises.",
          "The register remains sober, without emphasis, without promise.",
        ],
      },
    },

    {
      type: "references",
      items: [
        {
          image:
            "https://customer-assets.emergentagent.com/job_collection-privee/artifacts/ankqs57d_IMG-20260125-WA0003.jpg",
          alt: "Rosa — silhouette circulaire",
          caption: {
            fr: "Une silhouette circulaire, compacte. La conversation avait retenu cette économie.",
            en: "A circular, compact silhouette. The conversation had retained this economy.",
          },
        },
        {
          image:
            "https://customer-assets.emergentagent.com/job_collection-privee/artifacts/8p6wa68w_IMG-20260125-WA0006.jpg",
          alt: "Lumumba — lecture horizontale",
          caption: {
            fr: "La lecture horizontale, évoquée pour un bureau silencieux. À préciser en atelier.",
            en: "The horizontal reading, evoked for a quiet office. To be refined at the atelier.",
          },
        },
      ],
    },

    {
      type: "rythme",
      entries: [
        {
          date: "2026-06-15",
          phase: {
            fr: "Retour à l'atelier — première étude de silhouette",
            en: "Return to the atelier — first silhouette study",
          },
        },
        {
          date: "2026-07-05",
          phase: {
            fr: "Choix des matières — bois, métal, module",
            en: "Choice of materials — wood, metal, module",
          },
        },
        {
          date: "2026-09-10",
          phase: {
            fr: "Proposition écrite",
            en: "Written proposal",
          },
        },
      ],
    },
  ],
};

export default qaFixtureAlpha;
